import { motion } from 'framer-motion'
import React, { useMemo } from 'react'
import { StyledContainer, StyledContentWrapper, StyledLogoWrapper } from './styled'

const Intro = () => {
	const containerVariants = useMemo(
		() => ({
			initial: {
				display: 'none'
			},
			animate: {
				height: 100,
				transition: {
					duration: 2,
					delay: 1
				},
				opacity: 0,
				transitionEnd: {
					display: 'none'
				}
			}
		}),
		[]
	)

	const logoWrapperVariants = useMemo(
		() => ({
			initial: {},
			animate: {
				width: 128,
				// height: 110,
				transition: {
					duration: 1,
					delay: 1
				}
			}
		}),
		[]
	)

	const logoVariants = useMemo(
		() => ({
			initial: {},
			animate: {
				scale: 1,
				// height: 100,
				// width: 150,
				transition: {
					duration: 1,
					delay: 1
				}
				// transitionEnd: {
				// 	display: 'none'
				// }
			}
		}),
		[]
	)
	return (
		<StyledContainer variants={containerVariants} animate='animate' initial='initial'>
			<StyledContentWrapper
				animate={{ height: 'auto' }}
				transition={{ duration: 1, delay: 1 }}
			>
				<StyledLogoWrapper
					variants={logoWrapperVariants}
					animate='animate'
					initial='initial'
				>
					<motion.svg
						style={{ scale: 3 }}
						variants={logoVariants}
						initial='initial'
						animate='animate'
						width='177'
						height='46'
						viewBox='0 0 177 46'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<path
							d='M9.88003 17.6359C8.83211 16.0291 7.52222 14.7716 5.95034 13.8634C4.37847 12.9203 2.63194 12.4487 0.710757 12.4487V21.9324H3.17336C5.40892 21.9324 7.08558 22.4214 8.20336 23.3995C9.32114 24.3426 9.88003 26.0193 9.88003 28.4295V42H18.8397V12.7631H9.88003V17.6359Z'
							fill='#fff'
						/>
						<path
							d='M52.3487 26.7456C52.3487 27.5714 52.2971 28.4316 52.1938 29.3263H32.2193C32.3569 31.1155 32.9247 32.4919 33.9225 33.4554C34.9548 34.3844 36.2108 34.8489 37.6904 34.8489C39.8925 34.8489 41.4238 33.9199 42.284 32.0618H51.6777C51.196 33.9543 50.3185 35.6576 49.0454 37.1716C47.8067 38.6856 46.241 39.8727 44.3485 40.7329C42.456 41.5931 40.3399 42.0233 38 42.0233C35.1785 42.0233 32.6666 41.4211 30.4644 40.2168C28.2622 39.0125 26.5418 37.292 25.303 35.0554C24.0643 32.8188 23.4449 30.2037 23.4449 27.2101C23.4449 24.2165 24.0471 21.6014 25.2514 19.3648C26.4902 17.1282 28.2106 15.4077 30.4128 14.2034C32.615 12.9991 35.1441 12.3969 38 12.3969C40.7872 12.3969 43.2646 12.9819 45.4324 14.1518C47.6002 15.3217 49.2863 16.9906 50.4906 19.1583C51.7293 21.3261 52.3487 23.8552 52.3487 26.7456ZM43.3163 24.423C43.3163 22.9089 42.8001 21.7046 41.7678 20.81C40.7356 19.9153 39.4452 19.468 37.8968 19.468C36.4172 19.468 35.1613 19.8981 34.129 20.7584C33.1311 21.6186 32.5118 22.8401 32.2709 24.423H43.3163ZM55.2499 27.1585C55.2499 24.1993 55.8005 21.6014 56.9016 19.3648C58.0371 17.1282 59.5683 15.4077 61.4952 14.2034C63.4221 12.9991 65.5727 12.3969 67.9469 12.3969C69.8394 12.3969 71.5599 12.7926 73.1083 13.5841C74.6911 14.3755 75.9299 15.4422 76.8245 16.7841V3.41614H85.6505V41.6104H76.8245V37.4812C75.9987 38.8576 74.8116 39.9587 73.2632 40.7845C71.7491 41.6104 69.9771 42.0233 67.9469 42.0233C65.5727 42.0233 63.4221 41.4211 61.4952 40.2168C59.5683 38.978 58.0371 37.2404 56.9016 35.0038C55.8005 32.7328 55.2499 30.1177 55.2499 27.1585ZM76.8245 27.2101C76.8245 25.0079 76.2051 23.2702 74.9664 21.9971C73.7621 20.724 72.2825 20.0874 70.5276 20.0874C68.7727 20.0874 67.2759 20.724 66.0372 21.9971C64.8329 23.2358 64.2307 24.9563 64.2307 27.1585C64.2307 29.3607 64.8329 31.1155 66.0372 32.4231C67.2759 33.6962 68.7727 34.3328 70.5276 34.3328C72.2825 34.3328 73.7621 33.6962 74.9664 32.4231C76.2051 31.15 76.8245 29.4123 76.8245 27.2101ZM119.185 26.7456C119.185 27.5714 119.133 28.4316 119.03 29.3263H99.0551C99.1928 31.1155 99.7605 32.4919 100.758 33.4554C101.791 34.3844 103.047 34.8489 104.526 34.8489C106.728 34.8489 108.26 33.9199 109.12 32.0618H118.514C118.032 33.9543 117.154 35.6576 115.881 37.1716C114.643 38.6856 113.077 39.8727 111.184 40.7329C109.292 41.5931 107.176 42.0233 104.836 42.0233C102.014 42.0233 99.5025 41.4211 97.3003 40.2168C95.0981 39.0125 93.3776 37.292 92.1389 35.0554C90.9002 32.8188 90.2808 30.2037 90.2808 27.2101C90.2808 24.2165 90.8829 21.6014 92.0873 19.3648C93.326 17.1282 95.0465 15.4077 97.2487 14.2034C99.4508 12.9991 101.98 12.3969 104.836 12.3969C107.623 12.3969 110.1 12.9819 112.268 14.1518C114.436 15.3217 116.122 16.9906 117.326 19.1583C118.565 21.3261 119.185 23.8552 119.185 26.7456ZM110.152 24.423C110.152 22.9089 109.636 21.7046 108.604 20.81C107.571 19.9153 106.281 19.468 104.733 19.468C103.253 19.468 101.997 19.8981 100.965 20.7584C99.967 21.6186 99.3476 22.8401 99.1067 24.423H110.152ZM132.667 17.6099C133.699 16.0271 134.989 14.7884 136.538 13.8937C138.086 12.9647 139.807 12.5002 141.699 12.5002V21.8423H139.273C137.071 21.8423 135.419 22.324 134.318 23.2875C133.217 24.2165 132.667 25.8681 132.667 28.2424V41.6104H123.841V12.8098H132.667V17.6099ZM154.744 17.6099C155.776 16.0271 157.066 14.7884 158.615 13.8937C160.163 12.9647 161.884 12.5002 163.776 12.5002V21.8423H161.35C159.148 21.8423 157.496 22.324 156.395 23.2875C155.294 24.2165 154.744 25.8681 154.744 28.2424V41.6104H145.918V12.8098H154.744V17.6099Z'
							fill='#fff'
						/>
						<path
							d='M171.088 0.984442C172.037 0.984442 172.888 1.20529 173.64 1.64698C174.393 2.07231 174.982 2.66942 175.407 3.43829C175.832 4.1908 176.045 5.04147 176.045 5.99029C176.045 6.93911 175.832 7.79795 175.407 8.56683C174.982 9.3357 174.393 9.94098 173.64 10.3827C172.888 10.808 172.037 11.0207 171.088 11.0207C170.123 11.0207 169.264 10.808 168.512 10.3827C167.759 9.94098 167.17 9.3357 166.745 8.56683C166.319 7.79795 166.107 6.93911 166.107 5.99029C166.107 5.04147 166.319 4.1908 166.745 3.43829C167.17 2.66942 167.759 2.07231 168.512 1.64698C169.264 1.20529 170.123 0.984442 171.088 0.984442ZM171.088 10.0391C172.266 10.0391 173.215 9.66288 173.935 8.91036C174.671 8.15785 175.039 7.18449 175.039 5.99029C175.039 4.79608 174.671 3.82272 173.935 3.07021C173.215 2.3177 172.266 1.94144 171.088 1.94144C169.894 1.94144 168.937 2.3177 168.217 3.07021C167.514 3.82272 167.162 4.79608 167.162 5.99029C167.162 7.18449 167.514 8.15785 168.217 8.91036C168.937 9.66288 169.894 10.0391 171.088 10.0391ZM173.297 4.95967C173.297 5.35229 173.19 5.68765 172.978 5.96575C172.781 6.22749 172.503 6.41562 172.143 6.53013L173.517 8.56683L171.972 8.59136L170.794 6.62829H170.377V8.59136H169.101V3.3156H171.456C172.012 3.3156 172.454 3.46283 172.781 3.75729C173.125 4.05175 173.297 4.45254 173.297 4.95967ZM170.377 5.57313H171.383C171.563 5.57313 171.71 5.52406 171.824 5.4259C171.955 5.32775 172.021 5.1887 172.021 5.00875C172.021 4.8288 171.955 4.69793 171.824 4.61613C171.71 4.51798 171.563 4.4689 171.383 4.4689H170.377V5.57313Z'
							fill='#fff'
						/>
					</motion.svg>
				</StyledLogoWrapper>
			</StyledContentWrapper>
		</StyledContainer>
	)
}

export default Intro
